<template>
  <div class="c-retarget">
    <Row :gutter="12">
      <Col span="12">
        <div class="c-retarget-box" style="min-width: 475px">
          <div class="c-retarget-head g-clearfix">
            <span class="c-retarget-title">{{ title }}</span>
            <span class="c-retarget-attr">ID</span>
            <span class="c-retarget-attr">{{ attribe }}</span>
            <span class="c-tag-icon"
              >定向<Icon
                v-if="disallow('include') || !resultLen"
                type="ios-square-outline"
                color="#bcbcbc"
                :style="{ cursor: 'not-allowed' }"
                :size="16" /><Icon
                v-else-if="attrSelectAll('include')"
                type="ios-checkbox"
                color="#2d8cf0"
                :size="16"
                @click="changeRetargetAll('includes', false)" /><Icon
                v-else
                type="ios-square-outline"
                color="#dcdee2"
                :size="16"
                @click="changeRetargetAll('includes', true)"
            /></span>
            <span class="c-tag-icon"
              >排除<Icon
                v-if="disallow('exclude') || !resultLen"
                type="ios-square-outline"
                color="#bcbcbc"
                :style="{ cursor: 'not-allowed' }"
                :size="16" /><Icon
                v-else-if="attrSelectAll('exclude')"
                type="ios-checkbox"
                color="#2d8cf0"
                :size="16"
                @click="changeRetargetAll('excludes', false)" /><Icon
                v-else
                type="ios-square-outline"
                color="#dcdee2"
                :size="16"
                @click="changeRetargetAll('excludes', true)"
            /></span>
          </div>
          <Input v-model="search" suffix="ios-search" placeholder="请输入关键词" style="width: calc(100% - 11px); margin: 5px" />
          <div class="c-retartget-content" style="overflow-y: scroll">
            <div class="c-check-item g-clearfix" v-for="item in list" :key="item.id">
              <span class="item-span">{{ item.name }}</span>
              <RadioGroup v-model="item.select" style="float: right; height: 36px">
                <Radio label="include" :disabled="mutex(item) || auto"></Radio>
                <Radio label="exclude" :disabled="payTypeBag.includes(item.type) || mutex(item)"></Radio>
              </RadioGroup>
              <span class="item-type">{{ attriVal(item) }}</span>
              <span class="item-id">{{ item.id }}</span>
            </div>
          </div>
        </div>
      </Col>
      <Col span="6" offset="1">
        <div v-if="resultLen" class="c-retarget-box">
          <span class="c-retarget-clear" @click="$emit('on-clear', { list: data })">清空全部</span>
          <Tabs :value="currenTab" size="small">
            <TabPane
              :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`"
              class="c-retarget-result c-retarget-h"
              name="include"
            >
              <Tag v-for="item in includes" :key="item.id" :name="item.name" closable class="c-tag-item" @on-close="handleClose">{{
                item.name
              }}</Tag>
            </TabPane>
            <TabPane
              :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`"
              class="c-retarget-result c-retarget-h"
              name="exclude"
            >
              <Tag v-for="item in excludes" :key="item.id" :name="item.name" closable class="c-tag-item" @on-close="handleClose">{{
                item.name
              }}</Tag>
            </TabPane>
          </Tabs>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { toCountCrowd } from '@/common/js/filters'
import { audienceEnum } from '@/data/kuaishou/datas'

export default {
  name: 'retarget',
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    payTypeBag: {
      type: Array
    },
    media: {
      type: Number
    },
    currenTab: {
      type: String,
      default() {
        return 'include'
      }
    },
    auto: {
      type: Boolean
    }
  },
  computed: {
    list() {
      return this.data.filter((ret) => ret.name.indexOf(this.search) > -1)
    },
    resultLen() {
      return this.data.filter((ret) => ret.select === 'include' || ret.select === 'exclude').length
    },
    includes() {
      return this.data.filter((ret) => ret.select === 'include')
    },
    excludes() {
      return this.data.filter((ret) => ret.select === 'exclude')
    },
    attribe() {
      if (this.media === 16) return '覆盖数量'
      else return '属性'
    },
    attriVal() {
      return (item) => {
        if (this.media === 16) return toCountCrowd(item.count)
        else return audienceEnum[item.type] || '未知'
      }
    },
    mutex() {
      return ({ type, code }) => {
        const isCodeSame = this.includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && ret.code !== code)
        const isIncludesPayBag = this.includes.some(
          (ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type)
        )
        const isUnIncludesPayBag = this.includes.some(
          (ret) => ret.select && !this.payTypeBag.includes(ret.type) && this.payTypeBag.includes(type)
        )
        const isExcludes = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type))
        const isUnExcludesPayBag = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(type))
        return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
      }
    },
    attrSelectAll() {
      return (select) => {
        const bool = isArray(this.data) && this.data.length
        const mutex = ({ type, code }) => {
          const isCodeSame = this.includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && ret.code !== code)
          const isIncludesPayBag = this.includes.some(
            (ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type)
          )
          const isUnIncludesPayBag = this.includes.some(
            (ret) => ret.select && !this.payTypeBag.includes(ret.type) && this.payTypeBag.includes(type)
          )
          const isExcludes = this.excludes.some(
            (ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type)
          )
          const isUnExcludesPayBag = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(type))
          return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
        }
        if (select === 'exclude') return bool && this.list.filter((ret) => !mutex(ret)).every((ret) => ret.select === 'exclude')
        else if (select === 'include') return bool && this.list.filter((ret) => !mutex(ret)).every((ret) => ret.select === 'include')
      }
    },
    disallow() {
      const mutex = ({ type, code }) => {
        const isCodeSame = this.includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && ret.code !== code)
        const isIncludesPayBag = this.includes.some(
          (ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type)
        )
        const isUnIncludesPayBag = this.includes.some(
          (ret) => ret.select && !this.payTypeBag.includes(ret.type) && this.payTypeBag.includes(type)
        )
        const isExcludes = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type))
        const isUnExcludesPayBag = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(type))
        return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
      }
      return (type) => this.list.every((ret) => (type === 'include' ? this.auto : this.payTypeBag.includes(ret.type)) || mutex(ret))
    }
  },
  methods: {
    handleClose(event, name) {
      this.$emit('on-delete', { list: this.data, name })
    },
    changeRetargetAll(type, check) {
      const bool = Boolean(check)
      const mutex = ({ type, code }) => {
        const isCodeSame = this.includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && ret.code !== code)
        const isIncludesPayBag = this.includes.some(
          (ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type)
        )
        const isUnIncludesPayBag = this.includes.some(
          (ret) => ret.select && !this.payTypeBag.includes(ret.type) && this.payTypeBag.includes(type)
        )
        const isExcludes = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type))
        const isUnExcludesPayBag = this.excludes.some((ret) => ret.select && this.payTypeBag.includes(type))
        return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
      }
      if (isArray(this.list) || this.list.length) {
        this.list.forEach((ret) => {
          this.$set(ret, 'select', bool && !mutex(ret) ? type.substr(0, type.length - 1) : null)
        })
      }
    }
  },
  data() {
    return {
      search: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-retarget-box {
  position: relative;
  background-color: #fafbfe;
  border: solid 1px #dee4f5;
  padding: 0 !important;

  .c-retarget-head {
    padding: 0 8px 0 12px;
    height: 34px;
    text-align: right;
    color: #333;
    border-bottom: solid 1px #dee4f5;

    span {
      height: 34px;
      font-size: 12px;
      line-height: 34px;
      vertical-align: middle;
      margin-left: 8px;
    }

    .c-retarget-title {
      float: left;
      font-size: 14px;
      margin-left: 0;
    }

    .c-retarget-attr {
      display: inline-block;
      margin-right: 6px;
      width: 95px;
    }

    .c-tag-icon {
      margin-right: 0;

      .ivu-icon {
        cursor: pointer;
        margin: 0 0 0 3px;
      }
    }
  }

  .c-retarget-h {
    height: 285px !important;
  }

  .c-retartget-content,
  .c-retarget-result {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 246px;
    background-color: #fff;

    .c-check-item {
      margin: 0;
      padding-left: 12px;
      display: block;
      position: relative;
      height: 36px;
      line-height: 36px;
      cursor: pointer;

      &:hover {
        background-color: #f8f8f8;
      }

      .ivu-radio-wrapper {
        min-width: inherit;
        text-align: right;
        font-size: 0;
        margin-right: 14px;
      }

      .item-span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 215px;
        display: inline-block;
      }

      .item-type,
      .item-id {
        float: right;
        text-align: right;
      }

      .item-type {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 80px;
        margin-right: 22px;
      }

      .item-id {
        width: 60px;
        margin-right: 10px;
      }
    }
  }

  .c-retarget-clear {
    width: 60px;
    height: 34px;
    line-height: 34px;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    display: block;
    color: #598fe6;
    text-align: center;
    cursor: pointer;
  }

  .c-retarget-result {
    padding-bottom: 8px;
  }
}

.c-tag-item {
  margin: 8px 12px 0;
  padding: 2px 6px;
  display: block;
  font-size: 14px;
  height: 28px;
}
</style>
